module.exports = __webpack_public_path__ + "img/login6.21be52e9.jpg";